<template>
  <div class="attr-webpage">
    <div class="webpage-item flex-b-c">
      <span class="webpage-attr">{{$t('PE.Name')}}</span>
      <span>{{$t('PE.Webpage')}}</span>
    </div>
    <div class="webpage-item flex-b-c">
      <el-input :placeholder="$t('basics.PleaseInput')" v-model="media.ext_val_url" size="mini">
        <template slot="prepend">URL</template>
      </el-input>
    </div>
    <div class="webpage-item flex-b-c">
      <span class="webpage-attr">{{$t('PE.Scale')}}</span>
      <el-checkbox v-model="media.ext_val_scaleType">{{$t('PE.ConstrainProportions')}}</el-checkbox>
    </div>
    <div class="webpage-item flex-b-c">
      <span class="webpage-attr">{{$t('PE.EnterTheAnimation')}}</span>
      <el-select v-model="media.ext_val_anim" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
        <el-option v-for="item in animations" :key="item.id" :label="$t(item.i18n)" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="webpage-item flex-b-c">
      <span class="webpage-attr">{{$t('PE.TheEntryTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_enterTime" :min="1" size="mini"></el-input-number>
    </div>
    <div class="webpage-item flex-b-c">
      <span class="webpage-attr">{{$t('PE.PlayTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_duration" :min="1" size="mini"></el-input-number>
    </div>
  </div>
</template>

<script>
import animations from '../../scripts/animations';
export default {
  name: "AttrWebpage",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      animations,
      checked: false,
      num: 10,
    }
  },
  mounted() {
    console.log(this.media);
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.attr-webpage {
  padding-right: 4px;
  .webpage-item {
    min-height: 36px;
    margin: 8px 0px;
    // .webpage-attr {
    //   font-family: 'Times New Roman';
    //   font-weight: normal;
    //   font-stretch: normal;
    //   color: #617883;
    // }
  }
}
</style>